/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassModuleClassViewModel } from "../types/ClassModuleClassViewModel.ts";
import { eClassRoomDisciplinesStatusSchema } from "./eClassRoomDisciplinesStatusSchema.ts";

export const classModuleClassViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  startDate: z.optional(z.string().datetime()),
  endDate: z.optional(z.string().datetime()),
  status: z.optional(
    z
      .lazy(() => eClassRoomDisciplinesStatusSchema)
      .describe("1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | "),
  ),
}) as unknown as ToZod<ClassModuleClassViewModel>;
